import { ButtonLink, EntityChip, Icon } from '@silverfort/sf-components';

export interface ChipListItem {
    id: string;
    label: string;
}

export interface ChipListProps {
    data: ChipListItem[];
    listTitle: string;
    onRemove: (id: string) => void;
    onRemoveAll: () => void;
    clearButtonText?: string;
    removable?: boolean;
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
    isItemInvalid?: (label: string) => boolean;
    listClassName?: string;
    clearButtonClassName?: string;
    tableHeight?: string;
}

const ChipList = (params: ChipListProps) => {
    const {
        data,
        listTitle,
        onRemove,
        onRemoveAll,
        clearButtonText = 'Clear',
        removable = true,
        icon,
        isItemInvalid = () => false,
        listClassName = '',
        clearButtonClassName = '',
        tableHeight = 'h-full'
    } = params;

    return (
        <div>
            <div className={`${listClassName} border rounded-lg flex flex-col mt-4`}>
                <div className="flex text-12 items-center justify-between border-b px-3 py-2">
                    <span className="flex items-center text-sf-gray-500 text-12 gap-1">
                        {icon && <Icon icon={icon} className="h-4 w-4" />}
                        {listTitle ? `${listTitle} (${data.length})` : data.length}
                    </span>
                    <ButtonLink
                        text={clearButtonText}
                        onClick={onRemoveAll}
                        underline
                        className={clearButtonClassName}
                    />
                </div>
                <div
                    className={`flex flex-wrap items-start content-start gap-[8px] px-[10px] py-[8px]  overflow-y-auto ${tableHeight}`}>
                    {data.map((item, i) => (
                        <EntityChip
                            key={item.id}
                            text={item.label}
                            removable={removable}
                            onRemove={() => onRemove(item.id)}
                            invalid={isItemInvalid(item.label)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ChipList;
